/**
 * @ngdoc option
 * @name bo.options.controller:BoOptionCreateController
 *
 * @description
 *
 */
import {AbstractEditorController} from './abstract-editor-controller';

class BoOptionCreateController extends AbstractEditorController {

    constructor($injector) {
        super($injector);
        this.queue = this.injector.get('$q');
        this.headline = 'Create new option';
        this.model = {
            label: '',
            meta: {},
            meta_translated: {},
            billing_position_id: null
        };

        this.queue.all([
            this._loadObject(),
            this._loadAvailableTypes()
        ]).then(() => {
            this._updateNavigation();
        });
    }

    save() {
        this.api.post(`bo/objects/${this.objectModel.id}/options`, this._prepareModelForApi()).then((response) => {
            this.growl.success('Option was saved successful', {title: 'Success'});
            const newOption = response.data.data;
            this.state.go('app.bo.options.details', {
                id: newOption.id,
                objectId: this.objectModel.id
            });
        }, () => {
            this.growl.error('Please try again', {title: 'Save error'});
        });
    }

    cancel() {
        this.state.go('app.bo.options.index', {
            objectId: this.objectModel.id
        })
    }
}

angular
    .module('festzelt-os.modules.bo.options')
    .controller('BoOptionCreateController', BoOptionCreateController);



// WEBPACK FOOTER //
// ./src/app/modules/bo/options/controllers/create-controller.js